function generateRandom(length) {
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  var result = '';
  var arr = new Uint8Array(length || 64);
  crypto.getRandomValues(arr);
  arr.forEach(function(b) { result += chars[b % chars.length]; });
  return result;
}
async function sha256base64url(plain) {
  var encoder = new TextEncoder();
  var data = encoder.encode(plain);
  var hash = await crypto.subtle.digest('SHA-256', data);
  return btoa(String.fromCharCode(...new Uint8Array(hash))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function initiateLogin() {
  var verifier = generateRandom(64);
  var challenge = await sha256base64url(verifier);
  var state = generateRandom(32);
  var nonce = generateRandom(16);
  sessionStorage.setItem('pkce_verifier', verifier);
  sessionStorage.setItem('oauth_state', state);
  var params = new URLSearchParams({ client_id: SHOPIFY_CONFIG.clientId, response_type: 'code', redirect_uri: SHOPIFY_CONFIG.redirectUri, scope: SHOPIFY_CONFIG.scopes, state: state, nonce: nonce, code_challenge: challenge, code_challenge_method: 'S256' });
  window.location.href = SHOPIFY_CONFIG.authEndpoint + '?' + params.toString();
}
async function exchangeCodeForToken(code) {
  var verifier = sessionStorage.getItem('pkce_verifier');
  sessionStorage.removeItem('pkce_verifier');
  sessionStorage.removeItem('oauth_state');
  var body = new URLSearchParams({ grant_type: 'authorization_code', client_id: SHOPIFY_CONFIG.clientId, redirect_uri: SHOPIFY_CONFIG.redirectUri, code: code, code_verifier: verifier });
  var res = await fetch(SHOPIFY_CONFIG.tokenEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() });
  if (!res.ok) throw new Error('Token exchange failed');
  return await res.json();
}
async function handleLogout() {
  var idToken = localStorage.getItem('ca_id_token') || '';
  localStorage.removeItem('ca_access_token');
  localStorage.removeItem('ca_refresh_token');
  localStorage.removeItem('ca_expires_at');
  localStorage.removeItem('ca_id_token');
  var params = new URLSearchParams({ id_token_hint: idToken, post_logout_redirect_uri: SHOPIFY_CONFIG.redirectUri });
  window.location.href = SHOPIFY_CONFIG.logoutEndpoint + '?' + params.toString();
}
function getAccessToken() {
  var token = localStorage.getItem('ca_access_token');
  var expiresAt = parseInt(localStorage.getItem('ca_expires_at') || '0');
  if (!token || Date.now() > expiresAt) return null;
  return token;
}
// 2026-09-20: confirmed root cause for two separate symptoms (empty
// voucher list, consent modal never appearing) -- ca_access_token can
// remain valid while Shopify's classic session (logged_in_customer_id,
// what App-Proxy routes like /vouchers and /consent actually
// authenticate against) has desynced. A hard refresh does NOT fix this,
// since getAccessToken() still returns a valid token and DOMContentLoaded
// skips re-login entirely -- only a genuine new OAuth round-trip
// re-establishes the classic session, which is what manually logging out
// and back in was really doing. This automates that recovery on the
// specific failure (401) that indicates this desync, with a one-retry
// guard so a persistently broken account doesn't redirect-loop forever.
function handleAuthDesync() {
  // 2026-09-21: removed the removeItem() that used to sit here. Previously,
  // the guard cleared itself the SECOND time ANY caller hit it -- meaning
  // checkPendingConsent() and loadVouchers() each got their own independent
  // "first free retry," producing two separate redirects for one broken
  // session instead of one. The guard now only clears via the existing
  // success-path removeItem() calls already in loadVouchers()/
  // checkPendingConsent(), making retries page-session-wide rather than
  // per-function. (Root cause of that session's loop turned out to be
  // cross-tab cookie contention, not something this alone fixes -- see
  // purchaser-afo-panel-progress-handoff.md -- but this guard behavior
  // was still a real, independent bug worth correcting.)
  if (sessionStorage.getItem('auth_desync_retry')) {
    return false;
  }
  sessionStorage.setItem('auth_desync_retry', '1');
  initiateLogin();
  return true;
}
async function caFetch(query, variables) {
  var token = getAccessToken();
  if (!token) { initiateLogin(); return null; }
  var res = await fetch(SHOPIFY_CONFIG.apiEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': token }, body: JSON.stringify({ query: query, variables: variables || {} }) });
  if (res.status === 401) { initiateLogin(); return null; }
  var json = await res.json();
  if (json.errors) throw new Error(json.errors.map(function(e) { return e.message; }).join(', '));
  return json.data;
}
var GET_CUSTOMER = '\n  query {\n    customer {\n      id firstName lastName\n      emailAddress { emailAddress }\n      phoneNumber { phoneNumber }\n      defaultAddress { id firstName lastName company address1 address2 city province zip country }\n      addresses(first: 10) { nodes { id firstName lastName company address1 address2 city province zip country } }\n      metafield(namespace: "custom", key: "vat_tax_number") { value }\n      orders(first: 10, sortKey: PROCESSED_AT, reverse: true) {\n        pageInfo { hasNextPage endCursor }\n        nodes {\n          id name processedAt financialStatus fulfillmentStatus\n          totalPrice { amount currencyCode }\n          subtotal { amount currencyCode }\n          totalShipping { amount currencyCode }\n          totalTax { amount currencyCode }\n          fulfillments(first: 1) { nodes { trackingInformation { number url company } } }\n          lineItems(first: 10) { nodes { id title quantity variantTitle price { amount currencyCode } image { url altText } } }\n          shippingAddress { firstName lastName address1 address2 city province zip country }\n        }\n      }\n      orderStats: orders(first: 250, sortKey: PROCESSED_AT, reverse: true) {\n        nodes { totalPrice { amount currencyCode } }\n      }\n    }\n  }\n';
var LOAD_MORE_ORDERS = '\n  query loadMoreOrders($after: String!) {\n    customer {\n      orders(first: 10, after: $after, sortKey: PROCESSED_AT, reverse: true) {\n        pageInfo { hasNextPage endCursor }\n        nodes {\n          id name processedAt financialStatus fulfillmentStatus\n          totalPrice { amount currencyCode }\n          subtotal { amount currencyCode }\n          totalShipping { amount currencyCode }\n          totalTax { amount currencyCode }\n          fulfillments(first: 1) { nodes { trackingInformation { number url company } } }\n          lineItems(first: 10) { nodes { id title quantity variantTitle price { amount currencyCode } image { url altText } } }\n          shippingAddress { firstName lastName address1 address2 city province zip country }\n        }\n      }\n    }\n  }\n';
var UPDATE_CUSTOMER = '\n  mutation customerUpdate($input: CustomerUpdateInput!) {\n    customerUpdate(input: $input) {\n      customer { id firstName lastName phoneNumber { phoneNumber } }\n      userErrors { field message }\n    }\n  }\n';
var UPDATE_METAFIELD = '\n  mutation metafieldsSet($metafields: [MetafieldsSetInput!]!) {\n    metafieldsSet(metafields: $metafields) {\n      metafields { key value }\n      userErrors { field message }\n    }\n  }\n';
var CREATE_ADDRESS = '\n  mutation customerAddressCreate($address: CustomerAddressInput!) {\n    customerAddressCreate(address: $address) {\n      customerAddress { id }\n      userErrors { field message }\n    }\n  }\n';
var UPDATE_ADDRESS = '\n  mutation customerAddressUpdate($addressId: ID!, $address: CustomerAddressInput!, $defaultAddress: Boolean) {\n    customerAddressUpdate(addressId: $addressId, address: $address, defaultAddress: $defaultAddress) {\n      customerAddress { id }\n      userErrors { field message }\n    }\n  }\n';
var DELETE_ADDRESS = '\n  mutation customerAddressDelete($addressId: ID!) {\n    customerAddressDelete(addressId: $addressId) {\n      deletedAddressId\n      userErrors { field message }\n    }\n  }\n';
var COUNTRIES = [
  ['AF','Afghanistan'],['AL','Albania'],['DZ','Algeria'],['AD','Andorra'],['AO','Angola'],
  ['AI','Anguilla'],['AG','Antigua & Barbuda'],['AR','Argentina'],['AM','Armenia'],['AW','Aruba'],
  ['AU','Australia'],['AT','Austria'],['AZ','Azerbaijan'],['BS','Bahamas'],['BH','Bahrain'],
  ['BD','Bangladesh'],['BB','Barbados'],['BY','Belarus'],['BE','Belgium'],['BZ','Belize'],
  ['BJ','Benin'],['BM','Bermuda'],['BT','Bhutan'],['BO','Bolivia'],['BA','Bosnia & Herzegovina'],
  ['BW','Botswana'],['BR','Brazil'],['BN','Brunei'],['BG','Bulgaria'],['BF','Burkina Faso'],
  ['BI','Burundi'],['KH','Cambodia'],['CM','Cameroon'],['CA','Canada'],['CV','Cape Verde'],
  ['KY','Cayman Islands'],['CF','Central African Republic'],['TD','Chad'],['CL','Chile'],['CN','China'],
  ['CO','Colombia'],['KM','Comoros'],['CD','Congo (DRC)'],['CG','Congo'],['CR','Costa Rica'],
  ['CI',"Cote d'Ivoire"],['HR','Croatia'],['CU','Cuba'],['CW','Curacao'],['CY','Cyprus'],
  ['CZ','Czechia'],['DK','Denmark'],['DJ','Djibouti'],['DM','Dominica'],['DO','Dominican Republic'],
  ['EC','Ecuador'],['EG','Egypt'],['SV','El Salvador'],['GQ','Equatorial Guinea'],['ER','Eritrea'],
  ['EE','Estonia'],['SZ','Eswatini'],['ET','Ethiopia'],['FK','Falkland Islands'],['FO','Faroe Islands'],
  ['FJ','Fiji'],['FI','Finland'],['FR','France'],['GF','French Guiana'],['PF','French Polynesia'],
  ['GA','Gabon'],['GM','Gambia'],['GE','Georgia'],['DE','Germany'],['GH','Ghana'],
  ['GI','Gibraltar'],['GR','Greece'],['GL','Greenland'],['GD','Grenada'],['GP','Guadeloupe'],
  ['GT','Guatemala'],['GG','Guernsey'],['GN','Guinea'],['GW','Guinea-Bissau'],['GY','Guyana'],
  ['HT','Haiti'],['HN','Honduras'],['HK','Hong Kong SAR'],['HU','Hungary'],['IS','Iceland'],
  ['IN','India'],['ID','Indonesia'],['IR','Iran'],['IQ','Iraq'],['IE','Ireland'],
  ['IM','Isle of Man'],['IL','Israel'],['IT','Italy'],['JM','Jamaica'],['JP','Japan'],
  ['JE','Jersey'],['JO','Jordan'],['KZ','Kazakhstan'],['KE','Kenya'],['KI','Kiribati'],
  ['XK','Kosovo'],['KW','Kuwait'],['KG','Kyrgyzstan'],['LA','Laos'],['LV','Latvia'],
  ['LB','Lebanon'],['LS','Lesotho'],['LR','Liberia'],['LY','Libya'],['LI','Liechtenstein'],
  ['LT','Lithuania'],['LU','Luxembourg'],['MO','Macao SAR'],['MG','Madagascar'],['MW','Malawi'],
  ['MY','Malaysia'],['MV','Maldives'],['ML','Mali'],['MT','Malta'],['MQ','Martinique'],
  ['MR','Mauritania'],['MU','Mauritius'],['MX','Mexico'],['MD','Moldova'],['MC','Monaco'],
  ['MN','Mongolia'],['ME','Montenegro'],['MS','Montserrat'],['MA','Morocco'],['MZ','Mozambique'],
  ['MM','Myanmar'],['NA','Namibia'],['NR','Nauru'],['NP','Nepal'],['NL','Netherlands'],
  ['NC','New Caledonia'],['NZ','New Zealand'],['NI','Nicaragua'],['NE','Niger'],['NG','Nigeria'],
  ['MK','North Macedonia'],['NO','Norway'],['OM','Oman'],['PK','Pakistan'],['PS','Palestinian Territories'],
  ['PA','Panama'],['PG','Papua New Guinea'],['PY','Paraguay'],['PE','Peru'],['PH','Philippines'],
  ['PL','Poland'],['PT','Portugal'],['QA','Qatar'],['RE','Reunion'],['RO','Romania'],
  ['RU','Russia'],['RW','Rwanda'],['WS','Samoa'],['SM','San Marino'],['SA','Saudi Arabia'],
  ['SN','Senegal'],['RS','Serbia'],['SC','Seychelles'],['SL','Sierra Leone'],['SG','Singapore'],
  ['SX','Sint Maarten'],['SK','Slovakia'],['SI','Slovenia'],['SB','Solomon Islands'],['SO','Somalia'],
  ['ZA','South Africa'],['KR','South Korea'],['SS','South Sudan'],['ES','Spain'],['LK','Sri Lanka'],
  ['KN','St. Kitts & Nevis'],['LC','St. Lucia'],['VC','St. Vincent & Grenadines'],['SD','Sudan'],['SR','Suriname'],
  ['SE','Sweden'],['CH','Switzerland'],['SY','Syria'],['TW','Taiwan'],['TJ','Tajikistan'],
  ['TZ','Tanzania'],['TH','Thailand'],['TL','Timor-Leste'],['TG','Togo'],['TO','Tonga'],
  ['TT','Trinidad & Tobago'],['TN','Tunisia'],['TR','Turkiye'],['TM','Turkmenistan'],['TC','Turks & Caicos Islands'],
  ['TV','Tuvalu'],['UG','Uganda'],['UA','Ukraine'],['AE','United Arab Emirates'],['GB','United Kingdom'],
  ['US','United States'],['UY','Uruguay'],['UZ','Uzbekistan'],['VU','Vanuatu'],['VA','Vatican City'],
  ['VE','Venezuela'],['VN','Vietnam'],['VG','British Virgin Islands'],['YE','Yemen'],['ZM','Zambia'],
  ['ZW','Zimbabwe']
];
function populateCountrySelect() {
  var sel = document.getElementById('addr-country');
  if (!sel || sel.options.length) return;
  COUNTRIES.forEach(function(c) {
    var opt = document.createElement('option');
    opt.value = c[0];
    opt.textContent = c[1];
    sel.appendChild(opt);
  });
  sel.value = 'US';
}
function countryNameToCode(name) {
  if (!name) return 'US';
  var lower = name.trim().toLowerCase();
  var match = COUNTRIES.find(function(c) { return c[1].toLowerCase() === lower || c[0].toLowerCase() === lower; });
  return match ? match[0] : 'US';
}
var appState = { customer: null, currentOrder: null, ordersPageInfo: null, vouchers: null, vouchersLoaded: false, voucherSubTab: 'available', consentQueue: [], consentModalSeat: null, consentModalShown: false, revokedSearchQuery: '', revokedShownCount: 20, activeSearchQuery: '', collapsedProductRefs: {} };
document.addEventListener('DOMContentLoaded', async function() {
  populateCountrySelect();
  var params = new URLSearchParams(window.location.search);
  var code = params.get('code');
  var ostate = params.get('state');
  if (code) {
    var savedState = sessionStorage.getItem('oauth_state');
    if (ostate !== savedState) { alert('Security error. Please try again.'); initiateLogin(); return; }
    try {
      var tokens = await exchangeCodeForToken(code);
      var expiresAt = Date.now() + (tokens.expires_in * 1000);
      localStorage.setItem('ca_access_token', tokens.access_token);
      localStorage.setItem('ca_refresh_token', tokens.refresh_token || '');
      localStorage.setItem('ca_id_token', tokens.id_token || '');
      localStorage.setItem('ca_expires_at', expiresAt.toString());
      window.history.replaceState({}, '', window.location.pathname);
    } catch(e) { initiateLogin(); return; }
  }
  var token = getAccessToken();
  if (!token) { initiateLogin(); return; }
  document.getElementById('loading-screen').style.display = 'none';
  document.getElementById('account-screen').style.display = 'flex';
  await loadCustomer();
  // 2026-09-11: the recipient-side login trigger for Q1a's consent rework
  // (JOB-X-PROJECT-DOC.md) -- this IS "the recipient's own first
  // authenticated login" the design calls for: token is confirmed valid
  // above, so this runs on every session start, not just a first-ever
  // visit. Fire-and-forget -- a failure here must never block the rest of
  // the account page from rendering.
  checkPendingConsent();
});
function switchTab(tabName, navEl) {
  document.querySelectorAll('.ca-content').forEach(function(el) { el.classList.remove('active'); el.classList.add('hidden'); });
  var target = document.getElementById('tab-' + tabName);
  if (target) { target.classList.add('active'); target.classList.remove('hidden'); }
  if (navEl) { document.querySelectorAll('.ca-nav-item').forEach(function(el) { el.classList.remove('active'); }); navEl.classList.add('active'); }
  if (tabName === 'orders' && appState.customer) {
    document.getElementById('ca-page-title').textContent = 'Your orders';
  } else if (tabName === 'profile') {
    document.getElementById('ca-page-title').textContent = 'Profile';
  } else if (tabName === 'addresses') {
    document.getElementById('ca-page-title').textContent = 'Saved addresses';
  } else if (tabName === 'vouchers') {
    document.getElementById('ca-page-title').textContent = 'Access For Others Dashboard';
    loadVouchers();
  }
  var statsEl = document.querySelector('.ca-stats');
  if (statsEl) statsEl.classList.toggle('hidden', tabName === 'vouchers');
  document.querySelector('.ca-sidebar').classList.remove('open');
}

// --------------------------------------------------------------------------
// Job X §2.1-§2.3 -- voucher/seat-list tab.
// --------------------------------------------------------------------------
var REVOKED_PAGE_SIZE = 20;
function _revokedMatchesQuery(group, seat, query) {
  if (!query) return true;
  var q = query.toLowerCase();
  return (group.title && group.title.toLowerCase().indexOf(q) !== -1) ||
    (seat.recipient_email && seat.recipient_email.toLowerCase().indexOf(q) !== -1);
}
function filterAndPaginateRevoked(groups, query, shownCount) {
  var matches = [];
  groups.forEach(function(group) {
    group.seats.forEach(function(seat) {
      if (_revokedMatchesQuery(group, seat, query)) matches.push({ group: group, seat: seat });
    });
  });
  var totalMatches = matches.length;
  var shown = matches.slice(0, shownCount);
  var byRef = {};
  var order = [];
  shown.forEach(function(m) {
    var ref = m.group.product_ref;
    if (!byRef[ref]) { byRef[ref] = { product_ref: ref, title: m.group.title, seats: [] }; order.push(ref); }
    byRef[ref].seats.push(m.seat);
  });
  return { groups: order.map(function(ref) { return byRef[ref]; }),
           totalMatches: totalMatches, shownCount: shown.length };
}
function handleRevokedSearchInput(value) {
  appState.revokedSearchQuery = value;
  appState.revokedShownCount = REVOKED_PAGE_SIZE;
  if (appState.vouchersLoaded) renderVouchers(appState.vouchers);
}
function showMoreRevoked() {
  appState.revokedShownCount += REVOKED_PAGE_SIZE;
  renderVouchers(appState.vouchers);
}
function switchVoucherSubTab(sub, btnEl) {
  appState.voucherSubTab = sub;
  document.querySelectorAll('.voucher-subtab-btn').forEach(function(el) { el.classList.remove('active'); });
  if (btnEl) btnEl.classList.add('active');
  if (appState.vouchersLoaded) renderVouchers(appState.vouchers);
}
function voucherStatusClass(status) {
  if (status === 'Claimed') return 'status--fulfilled';
  if (status === 'Assigned') return 'status--pending';
  if (status === 'Revoked') return 'status--refunded';
  return 'status--unfulfilled';
}
var STATUS_FOR_SUBTAB = { available: 'Available', assigned: 'Assigned', claimed: 'Claimed' };
var STORE_LOGOS = {
  'Puppy Culture': 'https://cdn.shopify.com/s/files/1/1554/7897/files/PC-HEART-LOGO-FOR-TRADEMARK-WITH-REGISTRATION-MARK.png?v=1647005755',
  'Madcap': 'https://cdn.shopify.com/s/files/1/0360/4922/3818/files/madcap_university_logo_300.png?v=1675952311'
};
function renderStoreBadge(store, orderId) {
  var logo = STORE_LOGOS[store];
  var img = logo ? '<img src="' + esc(logo) + '" alt="" style="height:1rem;vertical-align:middle;margin-right:0.35rem;">' : '';
  return '<div class="order-row-meta">' + img + esc(store) +
    (orderId ? ' · Order ' + esc(orderId) : '') + '</div>';
}
function _activeMatchesQuery(seat, query) {
  if (!query) return true;
  var q = query.toLowerCase();
  return !!(seat.recipient_email && seat.recipient_email.toLowerCase().indexOf(q) !== -1);
}
function filterActiveByStatus(groups, status, query) {
  var out = [];
  groups.forEach(function(group) {
    var seats = group.seats.filter(function(seat) {
      return seat.display_status === status && _activeMatchesQuery(seat, query);
    });
    if (seats.length) out.push({ product_ref: group.product_ref, title: group.title, seats: seats });
  });
  return out;
}
function handleActiveSearchInput(value) {
  appState.activeSearchQuery = value;
  if (appState.vouchersLoaded) renderVouchers(appState.vouchers);
}
function toggleProductSection(productRef) {
  appState.collapsedProductRefs[productRef] = !appState.collapsedProductRefs[productRef];
  if (appState.vouchersLoaded) renderVouchers(appState.vouchers);
}
function formatWatchedDuration(totalSeconds) {
  // Legal-approved 2026-09-17 widening beyond the started/not_started
  // binary (purchaser-afo-panel-progress-handoff.md §4) -- a TOTAL
  // DURATION only, summed server-side across VIDEO units alone
  // (learnworlds.py's total_video_seconds_in_progress_body()). Never a
  // percentage or a fill bar: no total-course-video-length denominator
  // exists anywhere in this system to compute one against (confirmed by
  // repo-wide grep, 2026-09-21) -- don't add one here without
  // re-checking that constraint first.
  if (totalSeconds == null || totalSeconds < 60) return null;
  var mins = Math.floor(totalSeconds / 60);
  var hrs = Math.floor(mins / 60);
  mins = mins % 60;
  if (hrs > 0) return hrs + 'h ' + mins + 'm watched';
  return mins + 'm watched';
}
function renderEngagementBadge(engagement) {
  // Legally bounded (purchaser-afo-panel-progress-handoff.md §4): the
  // not_started/started binary + last_active_date + (as of 2026-09-21) a
  // total video-watched duration. Still never a percentage or a bar.
  // `engagement` is null for every migrated seat -- the PERMANENT common
  // case, not an error -- so this branch must read as calm, not broken.
  if (!engagement) {
    return '<div class="order-row-meta">No activity yet</div>';
  }
  var started = engagement.state === 'started';
  var label = started ? 'Started' : 'Not started yet';
  var cls = started ? 'status--fulfilled' : 'status--unfulfilled';
  // last_active_date confirmed live-null even when state is 'started'
  // (Seat 87, 2026-09-18) -- em-dash fallback required, not optional.
  var lastActive = 'Last active ' + (engagement.last_active_date ? formatDate(engagement.last_active_date) : '—');
  var watched = formatWatchedDuration(engagement.total_video_seconds);
  var watchedLine = watched ? '<div class="order-row-meta">' + watched + '</div>' : '';
  return '<span class="status-badge ' + cls + '" style="margin-left:0.5rem;">' + label + '</span>' +
    '<div class="order-row-meta">' + lastActive + '</div>' + watchedLine;
}
function refreshVouchers() {
  // 2026-09-20 (requested): manual refresh, bypassing loadVouchers()'s own
  // appState.vouchersLoaded cache guard -- without this, nothing short of
  // a full page reload would ever re-fetch after the first load.
  appState.vouchersLoaded = false;
  loadVouchers();
}
async function loadVouchers() {
  if (appState.vouchersLoaded) { renderVouchers(appState.vouchers); return; }
  var path = SHOPIFY_CONFIG.voucherProxyPath;
  document.getElementById('vouchers-loading').classList.remove('hidden');
  document.getElementById('vouchers-unavailable').classList.add('hidden');
  document.getElementById('vouchers-error').classList.add('hidden');
  if (!path) {
    document.getElementById('vouchers-loading').classList.add('hidden');
    document.getElementById('vouchers-unavailable').classList.remove('hidden');
    return;
  }
  try {
    var res = await fetch(path, { credentials: 'same-origin' });
    if (res.status === 401 && handleAuthDesync()) return;
    if (!res.ok) throw new Error('status ' + res.status);
    sessionStorage.removeItem('auth_desync_retry');
    var data = await res.json();
    appState.vouchers = data;
    appState.vouchersLoaded = true;
    renderVouchers(data);
  } catch(e) {
    console.error('Failed to load vouchers:', e);
    document.getElementById('vouchers-loading').classList.add('hidden');
    document.getElementById('vouchers-error').classList.remove('hidden');
  }
}
function renderVoucherGroup(group) {
  var collapsed = !!appState.collapsedProductRefs[group.product_ref];
  var rows = group.seats.map(function(seat) {
    var cls = voucherStatusClass(seat.display_status);
    var recipient = '';
    // Store logo + order number, matching the original MiniOrange dashboard's
    // per-seat purchase reference -- order_id/store are always populated
    // on every seat regardless of status (unlike recipient_email/
    // assigned_at/engagement, which are display-status-gated).
    var storeOrder = renderStoreBadge(seat.store, seat.order_name || seat.order_id);
    if (seat.recipient_email) {
      recipient = storeOrder + '<div class="order-row-meta">' + seat.recipient_email + '</div>';
      if (seat.assigned_at) {
        recipient += '<div class="order-row-meta">Assigned ' + formatDate(seat.assigned_at) + '</div>';
      }
      if (seat.display_status === 'Claimed') {
        recipient += renderEngagementBadge(seat.engagement);
      }
    } else {
      recipient = storeOrder;
    }
    var action = '';
    if (seat.can_revoke) {
      action = '<button class="btn btn--danger" style="margin-left:0.75rem" onclick="revokeSeat(' + seat.seat_id + ', this)">Revoke</button>';
    } else if (seat.display_status === 'Available') {
      action = '<button class="btn btn--secondary" style="margin-left:0.75rem" onclick="toggleAssignRow(' + seat.seat_id + ')">Assign</button>';
    }
    var assignRow = seat.display_status === 'Available'
      ? '<div id="assign-row-' + seat.seat_id + '" class="hidden" style="padding:0 16px 14px 16px;">' +
          '<input type="email" id="assign-email-' + seat.seat_id + '" name="recipient-email" autocomplete="email" placeholder="recipient@example.com" ' +
            'style="width:100%;padding:0.5rem 0.75rem;border:1px solid var(--border);border-radius:6px;box-sizing:border-box;">' +
          '<div style="margin-top:0.5rem;display:flex;gap:0.5rem;">' +
            '<button class="btn" onclick="confirmAssignSeat(' + seat.seat_id + ', this)">Confirm</button>' +
            '<button class="btn btn--secondary" onclick="toggleAssignRow(' + seat.seat_id + ')">Cancel</button>' +
          '</div>' +
          '<div id="assign-error-' + seat.seat_id + '" class="hidden" style="font-size:12px;color:#c0362c;margin-top:0.5rem;"></div>' +
        '</div>'
      : '';
    return '<div style="border-bottom:1px solid var(--border);">' +
      '<div class="order-row" style="cursor:default;border-bottom:none;">' +
        '<div style="flex:1;min-width:0;">' +
          '<div class="order-row-name">Seat ' + seat.seat_id + '</div>' +
          recipient +
        '</div>' +
        '<span class="status-badge ' + cls + '">' + seat.display_status + '</span>' +
        action +
      '</div>' +
      assignRow +
    '</div>';
  }).join('');
  var safeRef = group.product_ref.replace(/'/g, "\\'");
  return '<div class="card" id="course-' + encodeURIComponent(group.product_ref) + '" style="margin-bottom:12px;">' +
    '<div style="padding:0.75rem 1.25rem;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;cursor:pointer;" onclick="toggleProductSection(\'' + safeRef + '\')">' +
      '<span class="card-title">' + group.title + '</span>' +
      '<span style="font-size:12px;color:var(--text-secondary);display:flex;align-items:center;gap:6px;">' +
        group.seats.length + ' seat' + (group.seats.length === 1 ? '' : 's') +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="transition:transform 0.15s;transform:rotate(' + (collapsed ? '0' : '180') + 'deg);"><polyline points="6 9 12 15 18 9"/></svg>' +
      '</span>' +
    '</div>' +
    (collapsed ? '' : rows) +
  '</div>';
}
async function revokeSeat(seatId, btnEl) {
  if (!confirm('Revoke this seat? The recipient will lose access immediately.')) return;
  var path = SHOPIFY_CONFIG.voucherProxyPath;
  var originalText = btnEl ? btnEl.textContent : '';
  if (btnEl) { btnEl.disabled = true; btnEl.textContent = 'Revoking...'; }
  try {
    var res = await fetch(path + '/revoke', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ seat_id: seatId })
    });
    if (!res.ok) throw new Error('status ' + res.status);
    var data = await res.json();
    appState.vouchers = data;
    renderVouchers(data);
  } catch(e) {
    console.error('Failed to revoke seat:', e);
    alert('Could not revoke this seat. Please try again.');
    if (btnEl) { btnEl.disabled = false; btnEl.textContent = originalText || 'Revoke'; }
  }
}
function toggleAssignRow(seatId) {
  var row = document.getElementById('assign-row-' + seatId);
  if (!row) return;
  row.classList.toggle('hidden');
  if (!row.classList.contains('hidden')) {
    var input = document.getElementById('assign-email-' + seatId);
    if (input) { input.value = ''; input.focus(); }
  }
  var err = document.getElementById('assign-error-' + seatId);
  if (err) { err.classList.add('hidden'); err.textContent = ''; }
}
async function confirmAssignSeat(seatId, btnEl) {
  var input = document.getElementById('assign-email-' + seatId);
  var errEl = document.getElementById('assign-error-' + seatId);
  var email = input ? input.value.trim() : '';
  if (errEl) { errEl.classList.add('hidden'); errEl.textContent = ''; }
  if (!email) {
    if (errEl) { errEl.textContent = "Enter the recipient's email address."; errEl.classList.remove('hidden'); }
    return;
  }
  var path = SHOPIFY_CONFIG.voucherProxyPath;
  var originalText = btnEl ? btnEl.textContent : '';
  if (btnEl) { btnEl.disabled = true; btnEl.textContent = 'Assigning...'; }
  try {
    var res = await fetch(path + '/assign', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ seat_id: seatId, recipient_email: email })
    });
    if (!res.ok) {
      var message = 'Could not assign this seat. Please try again.';
      if (res.status === 400) message = "That doesn't look like a valid email address.";
      else if (res.status === 404) message = 'This seat could not be found on your account.';
      else if (res.status === 409) message = 'This seat was just claimed or changed -- refresh and try again.';
      else if (res.status === 422) {
        try { message = JSON.parse(await res.clone().text()).detail || message; }
        catch (e) { message = 'This recipient already has access to this course.'; }
      }
      if (errEl) { errEl.textContent = message; errEl.classList.remove('hidden'); }
      if (btnEl) { btnEl.disabled = false; btnEl.textContent = originalText || 'Confirm'; }
      return;
    }
    var data = await res.json();
    appState.vouchers = data;
    renderVouchers(data);
  } catch(e) {
    console.error('Failed to assign seat:', e);
    if (errEl) { errEl.textContent = 'Could not assign this seat. Please try again.'; errEl.classList.remove('hidden'); }
    if (btnEl) { btnEl.disabled = false; btnEl.textContent = originalText || 'Confirm'; }
  }
}
function renderVouchers(view) {
  document.getElementById('vouchers-loading').classList.add('hidden');
  var activeEl = document.getElementById('vouchers-active-list');
  var revokedEl = document.getElementById('vouchers-revoked-list');
  var activeEmpty = document.getElementById('vouchers-active-empty');
  var revokedEmpty = document.getElementById('vouchers-revoked-empty');
  var showActive = appState.voucherSubTab !== 'revoked';
  activeEl.classList.toggle('hidden', !showActive);
  revokedEl.classList.toggle('hidden', showActive);
  activeEmpty.classList.add('hidden');
  revokedEmpty.classList.add('hidden');
  if (showActive) {
    var status = STATUS_FOR_SUBTAB[appState.voucherSubTab] || 'Available';
    var filtered = filterActiveByStatus(view.active, status, appState.activeSearchQuery);
    var searchHtml = '<div style="margin-bottom:12px;">' +
      '<input type="search" placeholder="Search by recipient email" ' +
      'name="voucher-active-filter" ' +
      'value="' + (appState.activeSearchQuery || '').replace(/"/g, '&quot;') + '" ' +
      'oninput="handleActiveSearchInput(this.value)" ' +
      'autocomplete="off" ' +
      'style="width:100%;padding:0.5rem 0.75rem;border:1px solid var(--border);border-radius:6px;" />' +
    '</div>';
    var chipsHtml = filtered.length > 1
      ? '<div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:12px;">' +
        filtered.map(function(g) {
          return '<a href="#course-' + encodeURIComponent(g.product_ref) + '" ' +
            'style="font-size:12px;padding:4px 10px;border-radius:6px;background:var(--bg);' +
            'color:var(--text-muted);text-decoration:none;">' + g.title + '</a>';
        }).join('') +
      '</div>'
      : '';
    activeEl.classList.remove('hidden');
    if (!filtered.length) {
      activeEl.innerHTML = searchHtml;
      activeEmpty.classList.remove('hidden');
    } else {
      activeEl.innerHTML = searchHtml + chipsHtml + filtered.map(renderVoucherGroup).join('');
    }
  } else {
    if (!view.revoked.length) { revokedEmpty.classList.remove('hidden'); }
    else {
      revokedEl.classList.remove('hidden');
      var filteredR = filterAndPaginateRevoked(view.revoked, appState.revokedSearchQuery, appState.revokedShownCount);
      var searchHtmlR = '<div style="margin-bottom:12px;">' +
        '<input type="text" placeholder="Search revoked by product or recipient email" ' +
        'value="' + (appState.revokedSearchQuery || '').replace(/"/g, '&quot;') + '" ' +
        'oninput="handleRevokedSearchInput(this.value)" ' +
        'style="width:100%;padding:0.5rem 0.75rem;border:1px solid var(--border);border-radius:6px;" />' +
      '</div>';
      var listHtml = filteredR.groups.length
        ? filteredR.groups.map(renderVoucherGroup).join('')
        : '<div class="empty-state">No revoked seats match your search.</div>';
      var remaining = filteredR.totalMatches - filteredR.shownCount;
      var moreHtml = remaining > 0
        ? '<button class="btn btn--secondary" onclick="showMoreRevoked()" style="width:100%;margin-top:8px;">' +
          'Show ' + Math.min(REVOKED_PAGE_SIZE, remaining) + ' more (' + remaining + ' remaining)</button>'
        : '';
      revokedEl.innerHTML = searchHtmlR + listHtml + moreHtml;
    }
  }
  renderPendingConsentSection();
}

// --------------------------------------------------------------------------
// Q1a revision (2026-09-11, JOB-X-PROJECT-DOC.md) -- the login-triggered
// consent modal, and the "needs your confirmation" pending state in this
// same Access For Others tab.
// --------------------------------------------------------------------------
async function checkPendingConsent() {
  var path = SHOPIFY_CONFIG.voucherProxyPath;
  if (!path) return;
  try {
    var res = await fetch(path + '/consent', { credentials: 'same-origin' });
    if (res.status === 401 && handleAuthDesync()) return;
    if (!res.ok) throw new Error('status ' + res.status);
    sessionStorage.removeItem('auth_desync_retry');
    var data = await res.json();
    appState.consentQueue = (data.pending_consent || []).filter(function(s) { return s.consent_needed; });
  } catch(e) {
    console.error('Failed to check pending consent:', e);
    return;
  }
  renderPendingConsentSection();
  if (appState.consentQueue.length && !appState.consentModalShown) {
    openConsentModal(appState.consentQueue[0].seat_id);
  }
}
function renderPendingConsentSection() {
  var wrap = document.getElementById('vouchers-pending-consent');
  var listEl = document.getElementById('vouchers-pending-consent-list');
  if (!wrap || !listEl) return;
  if (!appState.consentQueue.length) { wrap.classList.add('hidden'); return; }
  wrap.classList.remove('hidden');
  listEl.innerHTML = appState.consentQueue.map(function(item) {
    return '<div class="order-row" style="cursor:default;">' +
      '<div style="flex:1;min-width:0;">' +
        '<div class="order-row-name">' + item.product_title + '</div>' +
      '</div>' +
      '<span class="status-badge status--pending">Needs confirmation</span>' +
      '<button class="btn btn--primary" style="margin-left:0.75rem" onclick="openConsentModal(' + item.seat_id + ')">Review</button>' +
    '</div>';
  }).join('');
}
function openConsentModal(seatId) {
  var seat = appState.consentQueue.find(function(s) { return s.seat_id === seatId; });
  if (!seat) return;
  appState.consentModalSeat = seat;
  appState.consentModalShown = true;
  document.getElementById('consent-modal-product').textContent = seat.product_title;
  document.getElementById('consent-checkbox').checked = false;
  clearAlert(document.getElementById('consent-modal-alert'));
  document.getElementById('consent-modal-body').classList.remove('hidden');
  document.getElementById('consent-modal-success').classList.add('hidden');
  document.getElementById('consent-modal-footer').classList.remove('hidden');
  var confirmBtn = document.getElementById('consent-confirm-btn');
  confirmBtn.disabled = false;
  confirmBtn.textContent = 'Confirm';
  var modal = document.getElementById('consent-modal');
  modal.classList.remove('hidden');
  modal.classList.add('active');
}
function dismissConsentModal(event) {
  if (event && event.target !== document.getElementById('consent-modal')) return;
  var modal = document.getElementById('consent-modal');
  modal.classList.add('hidden');
  modal.classList.remove('active');
}
async function confirmConsent() {
  var seat = appState.consentModalSeat;
  if (!seat) return;
  var alertEl = document.getElementById('consent-modal-alert');
  clearAlert(alertEl);
  if (!document.getElementById('consent-checkbox').checked) {
    showAlert(alertEl, 'Please check the box to continue.', 'error');
    return;
  }
  var path = SHOPIFY_CONFIG.voucherProxyPath;
  var confirmBtn = document.getElementById('consent-confirm-btn');
  confirmBtn.disabled = true;
  confirmBtn.textContent = 'Confirming...';
  try {
    var res = await fetch(path + '/consent', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ seat_id: seat.seat_id })
    });
    if (!res.ok) throw new Error('status ' + res.status);
    var data = await res.json();
    if (!data.ok) {
      showAlert(alertEl, "We couldn't finish setting up your access. Please try again in a moment.", 'error');
      confirmBtn.disabled = false;
      confirmBtn.textContent = 'Confirm';
      return;
    }
    appState.consentQueue = appState.consentQueue.filter(function(s) { return s.seat_id !== seat.seat_id; });
    renderPendingConsentSection();

    // 2026-09-20 (owner decision): chain straight into the next pending
    // seat's modal instead of stopping at a screen the recipient would
    // have to close, then separately notice and click "Review" on, to
    // handle a second course assigned in the same sitting. Only the LAST
    // seat in the queue reaches the final success screen below.
    if (appState.consentQueue.length > 0) {
      openConsentModal(appState.consentQueue[0].seat_id);
      return;
    }

    // No more pending seats. "Done" just closes the modal -- the
    // recipient lands back on the account page underneath it, where
    // "My Films and Courses" (already present, persistent, non-expiring
    // SSO link -- confirmed 2026-09-20, unlike activate_course_url) is
    // the real durable way back in, any time, not just today. No
    // separate hardcoded fallback link needed here; it would only
    // duplicate navigation the page already has. (Supersedes this same
    // day's earlier "Go to My Courses" button, removed per owner
    // feedback.)
    document.getElementById('consent-modal-body').classList.add('hidden');
    document.getElementById('consent-modal-footer').classList.add('hidden');
    var successEl = document.getElementById('consent-modal-success');
    successEl.classList.remove('hidden');
    var link = document.getElementById('consent-activate-link');
    if (data.activate_course_url) {
      link.href = data.activate_course_url;
      link.classList.remove('hidden');
    } else {
      link.classList.add('hidden');
    }
  } catch(e) {
    console.error('Failed to submit consent:', e);
    showAlert(alertEl, "We couldn't finish setting up your access. Please try again in a moment.", 'error');
    confirmBtn.disabled = false;
    confirmBtn.textContent = 'Confirm';
  }
}
async function loadCustomer() {
  try {
    var data = await caFetch(GET_CUSTOMER);
    if (!data) return;
    appState.customer = data.customer;
    var c = appState.customer;
    var initial = ((c.firstName || c.lastName || '?')[0]).toUpperCase();
    document.getElementById('ca-avatar').textContent = initial;
    document.getElementById('ca-name').textContent = (c.firstName || '') + ' ' + (c.lastName || '');
    document.getElementById('ca-email').textContent = (c.emailAddress && c.emailAddress.emailAddress) || '';
    var stats = c.orderStats.nodes;
    var totalSpent = stats.reduce(function(sum, o) { return sum + parseFloat(o.totalPrice.amount); }, 0);
    var currency = stats.length ? stats[0].totalPrice.currencyCode : 'USD';
    document.getElementById('stat-orders').textContent = stats.length;
    document.getElementById('stat-spent').textContent = formatMoney(totalSpent, currency);
    document.getElementById('stat-addresses').textContent = c.addresses.nodes.length;
    appState.ordersPageInfo = c.orders.pageInfo;
    renderOrders();
    prefillProfile();
    renderAddresses();
  } catch(e) { console.error('Failed to load customer:', e); }
}
function renderOrders() {
  document.getElementById('orders-loading').classList.add('hidden');
  var orders = appState.customer.orders.nodes;
  if (!orders.length) { document.getElementById('orders-empty').classList.remove('hidden'); return; }
  var listEl = document.getElementById('orders-list');
  listEl.classList.remove('hidden');
  listEl.innerHTML = orders.map(function(order) {
    var price = order.totalPrice;
    var cls = statusClass(order.fulfillmentStatus, order.financialStatus);
    var label = statusLabel(order.fulfillmentStatus, order.financialStatus);
    var firstItem = order.lineItems.nodes[0];
    var itemCount = order.lineItems.nodes.reduce(function(sum, i) { return sum + i.quantity; }, 0);
    var itemLabel = itemCount === 1 ? '1 item' : itemCount + ' items';
    var imgHtml = firstItem && firstItem.image && firstItem.image.url
      ? '<img src="' + firstItem.image.url + '" alt="" style="width:44px;height:44px;border-radius:8px;object-fit:cover;flex-shrink:0;" />'
      : '<div style="width:44px;height:44px;border-radius:8px;background:#F0EEE8;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0;">📦</div>';
    return '<div class="order-row" onclick="openOrderDetail(\'' + order.id + '\')">' +
      imgHtml +
      '<div style="flex:1;min-width:0;">' +
        '<div class="order-row-name">' + (firstItem ? firstItem.title : 'Order') + '</div>' +
        '<div class="order-row-meta">' + order.name + ' · ' + formatDate(order.processedAt) + ' · ' + itemLabel + '</div>' +
      '</div>' +
      '<div style="text-align:right;flex-shrink:0;">' +
        '<div class="order-row-price">' + formatMoney(price.amount, price.currencyCode) + '</div>' +
        '<span class="status-badge status--' + cls + '">' + label + '</span>' +
      '</div>' +
    '</div>';
  }).join('');
  var loadMoreWrap = document.getElementById('orders-load-more-wrap');
  if (appState.ordersPageInfo && appState.ordersPageInfo.hasNextPage) {
    loadMoreWrap.classList.remove('hidden');
  } else {
    loadMoreWrap.classList.add('hidden');
  }
}
async function loadMoreOrders() {
  if (!appState.ordersPageInfo || !appState.ordersPageInfo.hasNextPage) return;
  var loadMoreWrap = document.getElementById('orders-load-more-wrap');
  var btn = loadMoreWrap.querySelector('button');
  var originalText = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Loading...'; }
  try {
    var data = await caFetch(LOAD_MORE_ORDERS, { after: appState.ordersPageInfo.endCursor });
    if (!data) return;
    appState.customer.orders.nodes = appState.customer.orders.nodes.concat(data.customer.orders.nodes);
    appState.ordersPageInfo = data.customer.orders.pageInfo;
    renderOrders();
  } catch(e) {
    console.error('Failed to load more orders:', e);
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = originalText || 'Load more orders'; }
  }
}
function openOrderDetail(orderId) {
  var order = appState.customer.orders.nodes.find(function(o) { return o.id === orderId; });
  if (!order) return;
  appState.currentOrder = order;
  document.querySelectorAll('.ca-content').forEach(function(el) { el.classList.remove('active'); el.classList.add('hidden'); });
  document.querySelectorAll('.ca-nav-item').forEach(function(el) { el.classList.remove('active'); });
  var detailEl = document.getElementById('tab-order-detail');
  detailEl.classList.add('active'); detailEl.classList.remove('hidden');
  document.getElementById('ca-page-title').textContent = order.name;
  var el = document.getElementById('order-detail-content');
  var price = order.totalPrice;
  var subtotal = order.subtotal;
  var shipping = order.totalShipping;
  var tax = order.totalTax;
  var cls = statusClass(order.fulfillmentStatus, order.financialStatus);
  var label = statusLabel(order.fulfillmentStatus, order.financialStatus);
  var fulfillment = order.fulfillments && order.fulfillments.nodes && order.fulfillments.nodes[0];
  var tracking = fulfillment && fulfillment.trackingInformation && fulfillment.trackingInformation[0];
  var trackingHtml = tracking
    ? '<div class="tracking-banner"><div><div class="tracking-label">Tracking · ' + (tracking.company || '') + '</div><div class="tracking-num">' + tracking.number + '</div></div>' + (tracking.url ? '<a class="btn btn--outline" href="' + tracking.url + '" target="_blank" rel="noopener" style="margin-left:auto">Track package</a>' : '') + '</div>'
    : '';
  var lineItems = order.lineItems.nodes.map(function(item) {
    var imgHtml = item.image && item.image.url ? '<img class="line-item-img" src="' + item.image.url + '" alt="' + (item.image.altText || '') + '" />' : '<div class="line-item-img-placeholder">📦</div>';
    var variantLabel = item.variantTitle && item.variantTitle !== 'Default Title' ? item.variantTitle : '';
    var unitPrice = item.price ? formatMoney(item.price.amount, item.price.currencyCode) : '';
    var lineTotal = item.price ? formatMoney(parseFloat(item.price.amount) * item.quantity, item.price.currencyCode) : '';
    return '<div class="line-item">' + imgHtml + '<div class="line-item-info"><div class="line-item-name">' + item.title + '</div>' + (variantLabel ? '<div class="line-item-variant">' + variantLabel + '</div>' : '') + '<div class="line-item-variant">Qty ' + item.quantity + (unitPrice ? ' · ' + unitPrice + ' ea' : '') + '</div></div><div class="line-item-price">' + lineTotal + '</div></div>';
  }).join('');
  var addr = order.shippingAddress;
  var addrText = addr ? [addr.firstName + ' ' + addr.lastName, addr.address1, addr.city + ', ' + addr.province + ' ' + addr.zip].filter(Boolean).join(', ') : 'N/A';
  var vatNum = appState.customer.metafield && appState.customer.metafield.value;
  var vatRow = vatNum ? '<div class="totals-row"><span>VAT / Tax No.</span><span>' + vatNum + '</span></div>' : '';
  el.innerHTML =
    '<div class="order-meta-grid">' +
    '<div class="order-meta-cell"><div class="order-meta-label">Order date</div><div class="order-meta-value">' + formatDate(order.processedAt) + '</div></div>' +
    '<div class="order-meta-cell"><div class="order-meta-label">Status</div><div class="order-meta-value"><span class="status-badge status--' + cls + '">' + label + '</span></div></div>' +
    '<div class="order-meta-cell"><div class="order-meta-label">Ship to</div><div class="order-meta-value" style="font-size:0.8rem;font-weight:500">' + addrText + '</div></div>' +
    '</div>' + trackingHtml +
    '<div class="line-items-table">' + lineItems + '</div>' +
    '<div class="order-totals">' +
    '<div class="totals-row"><span>Subtotal</span><span>' + (subtotal ? formatMoney(subtotal.amount, subtotal.currencyCode) : '—') + '</span></div>' +
    '<div class="totals-row"><span>Shipping</span><span>' + (shipping ? formatMoney(shipping.amount, shipping.currencyCode) : '—') + '</span></div>' +
    '<div class="totals-row"><span>Tax</span><span>' + (tax ? formatMoney(tax.amount, tax.currencyCode) : '—') + '</span></div>' +
    vatRow +
    '<div class="totals-row total"><span>Total</span><span>' + formatMoney(price.amount, price.currencyCode) + '</span></div>' +
    '</div>';
}
function prefillProfile() {
  var c = appState.customer;
  document.getElementById('p-first').value = c.firstName || '';
  document.getElementById('p-last').value  = c.lastName  || '';
  document.getElementById('p-email').value = (c.emailAddress && c.emailAddress.emailAddress) || '';
  document.getElementById('p-phone').value = (c.phoneNumber && c.phoneNumber.phoneNumber) || '';
  document.getElementById('p-vat').value   = (c.metafield && c.metafield.value) || '';
}
async function saveProfile() {
  var alertEl = document.getElementById('profile-alert');
  clearAlert(alertEl);
  var vatValue = document.getElementById('p-vat').value.trim();
  var input = {
    firstName: document.getElementById('p-first').value.trim(),
    lastName:  document.getElementById('p-last').value.trim()
  };
  try {
    var data = await caFetch(UPDATE_CUSTOMER, { input: input });
    if (!data) return;
    var errs = data.customerUpdate.userErrors;
    if (errs.length) { showAlert(alertEl, errs.map(function(e) { return e.message; }).join(', '), 'error'); return; }
    var metaData = await caFetch(UPDATE_METAFIELD, { metafields: [{ ownerId: appState.customer.id, namespace: 'custom', key: 'vat_tax_number', value: vatValue, type: 'single_line_text_field' }] });
    if (metaData) {
      var metaErrs = metaData.metafieldsSet.userErrors;
      if (metaErrs.length) { showAlert(alertEl, metaErrs.map(function(e) { return e.message; }).join(', '), 'error'); return; }
    }
    await loadCustomer();
    showAlert(alertEl, 'Your profile has been saved.', 'success');
  } catch(e) { showAlert(alertEl, e.message || 'Failed to save profile.', 'error'); }
}
function renderAddresses() {
  var listEl = document.getElementById('addresses-list');
  var addresses = appState.customer.addresses.nodes;
  var defaultId = appState.customer.defaultAddress && appState.customer.defaultAddress.id;
  if (!addresses.length) {
    listEl.innerHTML = '<div class="empty-state"><div class="empty-icon">📍</div><p class="empty-title">No saved addresses</p><p class="empty-sub">Add an address to speed up checkout.</p></div>';
    return;
  }
  listEl.innerHTML = addresses.map(function(addr) {
    var isDefault = addr.id === defaultId;
    var name = [addr.firstName, addr.lastName].filter(Boolean).join(' ');
    var lines = [addr.company, addr.address1, addr.address2, [addr.city, addr.province, addr.zip].filter(Boolean).join(', '), addr.country].filter(Boolean);
    return '<div class="address-card ' + (isDefault ? 'is-default' : '') + '">' +
      '<div>' + (isDefault ? '<div class="address-default-badge">Default</div>' : '') +
      '<div class="address-text"><div class="address-name">' + name + '</div>' + lines.map(function(l) { return '<div>' + l + '</div>'; }).join('') + '</div></div>' +
      '<div class="address-actions">' +
      (!isDefault ? '<button class="btn btn--ghost" style="font-size:0.8rem;padding:0.4rem 0.75rem" onclick="setDefaultAddress(\'' + addr.id + '\')">Set default</button>' : '') +
      '<button class="btn btn--ghost" style="font-size:0.8rem;padding:0.4rem 0.75rem" onclick="openAddressForm(\'' + addr.id + '\')">Edit</button>' +
      '<button class="btn btn--danger" onclick="deleteAddress(\'' + addr.id + '\')">Remove</button>' +
      '</div></div>';
  }).join('');
}
function openAddressForm(addrId) {
  var modal = document.getElementById('address-modal');
  ['addr-id','addr-first','addr-last','addr-company','addr-1','addr-2','addr-city','addr-zip','addr-province','addr-phone'].forEach(function(id) { document.getElementById(id).value = ''; });
  document.getElementById('addr-country').value = 'US';
  document.getElementById('addr-default').checked = false;
  clearAlert(document.getElementById('address-alert'));
  if (addrId) {
    document.getElementById('modal-title').textContent = 'Edit address';
    var addr = appState.customer.addresses.nodes.find(function(a) { return a.id === addrId; });
    if (addr) {
      document.getElementById('addr-id').value = addr.id;
      document.getElementById('addr-first').value = addr.firstName || '';
      document.getElementById('addr-last').value = addr.lastName || '';
      document.getElementById('addr-company').value = addr.company || '';
      document.getElementById('addr-1').value = addr.address1 || '';
      document.getElementById('addr-2').value = addr.address2 || '';
      document.getElementById('addr-city').value = addr.city || '';
      document.getElementById('addr-zip').value = addr.zip || '';
      document.getElementById('addr-province').value = addr.province || '';
      document.getElementById('addr-country').value = countryNameToCode(addr.country);
      document.getElementById('addr-default').checked = addr.id === (appState.customer.defaultAddress && appState.customer.defaultAddress.id);
    }
  } else {
    document.getElementById('modal-title').textContent = 'Add address';
  }
  modal.classList.remove('hidden'); modal.classList.add('active');
}
function closeAddressModal(event) {
  if (event && event.target !== document.getElementById('address-modal')) return;
  document.getElementById('address-modal').classList.add('hidden');
  document.getElementById('address-modal').classList.remove('active');
}
async function saveAddress() {
  var alertEl = document.getElementById('address-alert');
  clearAlert(alertEl);
  var id = document.getElementById('addr-id').value;
  var address = {
    firstName: document.getElementById('addr-first').value.trim(),
    lastName: document.getElementById('addr-last').value.trim(),
    company: document.getElementById('addr-company').value.trim() || null,
    address1: document.getElementById('addr-1').value.trim(),
    address2: document.getElementById('addr-2').value.trim() || null,
    city: document.getElementById('addr-city').value.trim(),
    zip: document.getElementById('addr-zip').value.trim(),
    zoneCode: document.getElementById('addr-province').value.trim(),
    territoryCode: document.getElementById('addr-country').value,
    phoneNumber: document.getElementById('addr-phone').value.trim() || null,
  };
  var setDefault = document.getElementById('addr-default').checked;
  if (!address.firstName || !address.lastName || !address.address1 || !address.city || !address.zip) { showAlert(alertEl, 'Please fill in all required fields.', 'error'); return; }
  try {
    var data, errs;
    if (id) {
      data = await caFetch(UPDATE_ADDRESS, { addressId: id, address: address, defaultAddress: setDefault });
      errs = (data && data.customerAddressUpdate && data.customerAddressUpdate.userErrors) || [];
    } else {
      data = await caFetch(CREATE_ADDRESS, { address: address });
      errs = (data && data.customerAddressCreate && data.customerAddressCreate.userErrors) || [];
    }
    if (errs.length) { showAlert(alertEl, errs.map(function(e) { return e.message; }).join(', '), 'error'); return; }
    closeAddressModal();
    await loadCustomer();
    renderAddresses();
  } catch(e) { showAlert(alertEl, e.message || 'Failed to save address.', 'error'); }
}
async function deleteAddress(id) {
  if (!confirm('Remove this address?')) return;
  try { await caFetch(DELETE_ADDRESS, { addressId: id }); await loadCustomer(); renderAddresses(); } catch(e) { alert(e.message); }
}
async function setDefaultAddress(id) {
  try { await caFetch(UPDATE_ADDRESS, { addressId: id, address: {}, defaultAddress: true }); await loadCustomer(); renderAddresses(); } catch(e) { alert(e.message); }
}
function printReceipt() {
  if (!appState.currentOrder) return;
  var order = appState.currentOrder;
  var cfg = SHOPIFY_CONFIG;
  var price = order.totalPrice;
  var subtotal = order.subtotal;
  var shipping = order.totalShipping;
  var tax = order.totalTax;
  var label = statusLabel(order.fulfillmentStatus, order.financialStatus);
  var addr = order.shippingAddress;
  var shipLines = addr ? [[addr.firstName, addr.lastName].filter(Boolean).join(' '), addr.address1, addr.address2, [addr.city, addr.province, addr.zip].filter(Boolean).join(', '), addr.country].filter(Boolean) : ['No shipping address'];
  var c = appState.customer;
  var vatNum = c.metafield && c.metafield.value;
  var billLines = [[c.firstName, c.lastName].filter(Boolean).join(' '), c.emailAddress && c.emailAddress.emailAddress, c.phoneNumber && c.phoneNumber.phoneNumber].filter(Boolean);
  var lineItemsHtml = order.lineItems.nodes.map(function(item) {
    var unitPrice = item.price ? formatMoney(item.price.amount, item.price.currencyCode) : '';
    var lineTotal = item.price ? formatMoney(parseFloat(item.price.amount) * item.quantity, item.price.currencyCode) : '';
    var variantLabel = item.variantTitle && item.variantTitle !== 'Default Title' ? item.variantTitle : '';
    return '<tr><td><div>' + item.title + '</div>' + (variantLabel ? '<div style="font-size:8.5pt;color:#777;margin-top:2px">' + variantLabel + '</div>' : '') + '</td><td>' + unitPrice + '</td><td style="text-align:center">' + item.quantity + '</td><td>' + lineTotal + '</td></tr>';
  }).join('');
  var fulfillment = order.fulfillments && order.fulfillments.nodes && order.fulfillments.nodes[0];
  var tracking = fulfillment && fulfillment.trackingInformation && fulfillment.trackingInformation[0];
  var trackingRow = tracking ? '<tr><td colspan="3" style="color:#888;font-size:8.5pt">Tracking: ' + (tracking.company || '') + ' ' + tracking.number + '</td><td></td></tr>' : '';
  var vatReceiptRow = vatNum ? '<div class="tr"><span>VAT / Tax No.</span><span>' + vatNum + '</span></div>' : '';
  var styles = 'body{font-family:Arial,sans-serif;font-size:12pt;color:#000;margin:0;padding:0}.receipt{max-width:680px;margin:0 auto;padding:40px}.rh{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #1B2B4B;padding-bottom:20px;margin-bottom:24px}.sn{font-size:20pt;font-weight:700;margin-bottom:6px;color:#1B2B4B}.sd{font-size:9pt;color:#555;line-height:1.6}.rm{text-align:right;font-size:9pt;line-height:1.7}.ml{font-weight:700;text-transform:uppercase;font-size:7.5pt;color:#888}.mv{font-size:10pt;font-weight:600;color:#000}.rt{font-size:13pt;font-weight:700;text-transform:uppercase;letter-spacing:.08em;color:#1B2B4B;margin-bottom:16px}.addr{display:flex;gap:40px;margin-bottom:28px}.ab{flex:1}.al{font-size:7.5pt;font-weight:700;text-transform:uppercase;color:#888;margin-bottom:6px}.at{font-size:10pt;line-height:1.6;color:#222}table{width:100%;border-collapse:collapse;margin-bottom:24px}th{font-size:8pt;font-weight:700;text-transform:uppercase;color:#888;padding:8px 10px;border-bottom:1px solid #ccc;text-align:left}th:last-child,td:last-child{text-align:right}td{padding:10px;font-size:10pt;color:#222;border-bottom:1px solid #eee;vertical-align:top}.tots{margin-left:auto;width:280px;margin-bottom:32px}.tr{display:flex;justify-content:space-between;padding:5px 0;font-size:10pt;color:#444;border-bottom:1px solid #eee}.grand{font-size:12pt;font-weight:700;color:#000;border-bottom:2px solid #1B2B4B;border-top:1px solid #1B2B4B;padding:8px 0}.foot{text-align:center;font-size:8.5pt;color:#888;border-top:1px solid #ddd;padding-top:16px;margin-top:12px;line-height:1.8}.st{display:inline-block;font-size:8pt;font-weight:700;text-transform:uppercase;padding:3px 8px;border:1.5px solid #1B2B4B;border-radius:4px;color:#1B2B4B}.vat-badge{display:inline-block;background:#EEF4FA;color:#1B2B4B;font-size:8pt;font-weight:700;padding:3px 8px;border-radius:4px;margin-top:4px}';
  var logoHtml = cfg.logoUrl ? '<img src="' + cfg.logoUrl + '" alt="' + cfg.storeName + '" style="max-height:60px;max-width:220px;margin-bottom:12px;display:block;" />' : '';
var body = '<div class="receipt"><div class="rh"><div>' + logoHtml + '<div class="sn">' + cfg.storeName + '</div><div class="sd">' + [cfg.storeAddress, cfg.storePhone, cfg.storeEmail, cfg.storeWebsite].filter(Boolean).join('<br>') + '</div></div><div class="rm"><div class="ml">Order</div><div class="mv">' + order.name + '</div><br><div class="ml">Date</div><div class="mv">' + formatDate(order.processedAt) + '</div><br><div class="ml">Status</div><div class="mv"><span class="st">' + label + '</span></div></div></div><div class="rt">Order Receipt</div><div class="addr"><div class="ab"><div class="al">Bill to</div><div class="at">' + billLines.join('<br>') + (vatNum ? '<br><span class="vat-badge">VAT: ' + vatNum + '</span>' : '') + '</div></div><div class="ab"><div class="al">Ship to</div><div class="at">' + shipLines.join('<br>') + '</div></div></div><table><thead><tr><th style="width:50%">Item</th><th>Unit price</th><th style="text-align:center">Qty</th><th>Total</th></tr></thead><tbody>' + lineItemsHtml + trackingRow + '</tbody></table><div class="tots"><div class="tr"><span>Subtotal</span><span>' + (subtotal ? formatMoney(subtotal.amount, subtotal.currencyCode) : '—') + '</span></div><div class="tr"><span>Shipping</span><span>' + (shipping ? formatMoney(shipping.amount, shipping.currencyCode) : '—') + '</span></div><div class="tr"><span>Tax</span><span>' + (tax ? formatMoney(tax.amount, tax.currencyCode) : '—') + '</span></div>' + vatReceiptRow + '<div class="tr grand"><span>Total</span><span>' + formatMoney(price.amount, price.currencyCode) + '</span></div></div><div class="foot">Thank you for your order!<br>' + (cfg.storeWebsite ? cfg.storeWebsite + ' &nbsp;·&nbsp; ' : '') + (cfg.storeEmail ? cfg.storeEmail + ' &nbsp;·&nbsp; ' : '') + (cfg.storePhone || '') + '</div></div>';
  var win = window.open('', '_blank', 'width=800,height=600');
  win.document.write('<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Receipt ' + order.name + '</title><style>' + styles + '</style></head><body>' + body + '</body></html>');
  win.document.close();
  win.focus();
  setTimeout(function() { win.print(); }, 500);
}
function formatMoney(amount, currencyCode) { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currencyCode || 'USD' }).format(parseFloat(amount)); }
function formatDate(iso) { return new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }); }
function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
function statusClass(fulfillment, financial) {
  if (financial === 'REFUNDED') return 'refunded';
  if (fulfillment === 'FULFILLED') return 'fulfilled';
  if (fulfillment === 'PARTIALLY_FULFILLED') return 'unfulfilled';
  if (financial === 'PENDING') return 'pending';
  return 'unfulfilled';
}
function statusLabel(fulfillment, financial) {
  if (financial === 'REFUNDED') return 'Refunded';
  if (fulfillment === 'FULFILLED') return 'Fulfilled';
  if (fulfillment === 'PARTIALLY_FULFILLED') return 'Partially fulfilled';
  if (financial === 'PENDING') return 'Pending';
  return 'Processing';
}
function showAlert(el, msg, type) { el.textContent = msg; el.className = 'alert alert--' + (type || 'error'); el.classList.remove('hidden'); }
function clearAlert(el) { el.textContent = ''; el.classList.add('hidden'); }